import { useMemo } from 'react';

export function parseWalletQty(raw) {
    if (raw == null || raw === '') return 0;
    if (typeof raw === 'number') return Number.isFinite(raw) ? raw : 0;
    if (typeof raw === 'object') {
        return parseWalletQty(raw.current ?? raw.available ?? raw.qty ?? raw.free);
    }
    const num = Number(raw);
    return Number.isFinite(num) ? num : 0;
}

/**
 * props:
 * - wallet
 */
function WalletSummary(props) {

    function getText(qty) {
        const num = parseWalletQty(qty);
        const qtyStr = `${num}`;
        if (qtyStr.indexOf('.') === -1) return qtyStr;

        const decimals = Math.min(qtyStr.split('.')[1].length, 8);
        return num.toFixed(decimals);
    }

    function amountClass(qty) {
        return parseWalletQty(qty) > 0 ? 'alert-success' : 'alert-warning';
    }

    const base = props.wallet && props.wallet.base ? props.wallet.base : { symbol: '', qty: 0 };
    const quote = props.wallet && props.wallet.quote ? props.wallet.quote : { symbol: '', qty: 0 };

    const walletSummary = useMemo(() => (
        <div className="row">
            <div className="col-md-6 mb-3">
                <div className="form-group">
                    <div className={`alert py-1 ${amountClass(base.qty)}`}>
                        {`${base.symbol}: ${parseWalletQty(base.qty) ? getText(base.qty) : 0}`}
                    </div>
                </div>
            </div>
            <div className="col-md-6 mb-3">
                <div className="form-group">
                    <div className={`alert py-1 ${parseWalletQty(quote.qty) > 0 ? 'alert-info' : 'alert-warning'}`}>
                        {`${quote.symbol}: ${parseWalletQty(quote.qty) ? getText(quote.qty) : 0}`}
                    </div>
                </div>
            </div>
        </div>
    ), [base, quote])

    return walletSummary;
}

export default WalletSummary;
